import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';

import { RHFAutoComplete } from '@openx/components-core/lib/AutoComplete/RHFAutoComplete';
import { RHFTextField } from '@openx/components-core/lib/TextField/RHFTextField';

export const StyledRHFTextField = styled(RHFTextField)`
  margin: ${({ theme }) => theme.spacing(0.5)};
  max-width: 481px;
`;

export const StyledTooltip = styled(Tooltip)`
  top: ${({ theme }) => theme.spacing(0.25)};
`;

export const StyledBox = styled(Box)`
  display: inline-flex;
  justify-content: start;
  align-items: center;
  width: 100%;
  gap: ${({ theme }) => theme.spacing(1)};
  margin: ${({ theme }) => theme.spacing(0.5)};
`;

export const StyledFixedSizeAutoComplete = styled(RHFAutoComplete)`
  min-width: 160px;
  width: 30%;
` as typeof RHFAutoComplete;

export const StyledBoxMargined = styled(Box)`
  margin-left: ${({ theme }) => theme.spacing(1.5)};
  margin-top: ${({ theme }) => theme.spacing(0.75)};
`;

export const StyledFormControlMargined = styled(FormControl)`
  margin-left: ${({ theme }) => theme.spacing(2.5)};
`;
